import React, { useState } from 'react';
import { useSurvey } from '../../../context/SurveyContext';
import QuestionTypesSidebar from './QuestionTypesSidebar';
import SurveyCanvas from './SurveyCanvas';
import QuestionSettings from './QuestionSettings';
import TopBar from './TopBar';
import AnalysisReminder from './AnalysisReminder';
import './QuestionBuilder.css';

const QuestionBuilder = () => {
  const { currentSurvey, selectedQuestionId } = useSurvey();
  const [showSettings, setShowSettings] = useState(true);

  if (!currentSurvey) {
    return <div className="no-survey">No survey selected</div>;
  }

  return (
    <div className="question-builder">
      <TopBar />
      <AnalysisReminder />
      <div className="builder-main">
        <QuestionTypesSidebar />
        <SurveyCanvas />
        {showSettings && selectedQuestionId && (
          <QuestionSettings onClose={() => setShowSettings(false)} />
        )}
      </div>
    </div>
  );
};

export default QuestionBuilder;
